import React from 'react'
import { communityFeatures } from "../../../mock/communityFeatures"
import { Section } from "../../ui"
import './communityFeatures.scss'

import '../../../assets/images/spotlight.png'
import '../../../assets/images/readers_room.png'
import '../../../assets/images/hashrate_tv.png'
import '../../../assets/images/writers_workshop.png'


const CommunityFeaturesSection = () => {

    return (
        <Section variant="grey" id="community">
            <div className="communityFeatures">
                <h2 className="communityFeatures-title">Our Community Features</h2>
                <ul className="communityFeatures-list_wrapper">
                    {
                        communityFeatures.map(({icon, title, description}) => (
                            <li key={title} className="item_wrapper">
                                <img src={require(icon)}/>
                                <h3>{title}</h3>
                                <p>{description}</p>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </Section>
    )
}

export default CommunityFeaturesSection
